// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Nr-z","giftOrPromoSelector":"Or-z","disabled":"Pr-z","subTitle":"Qr-z","selectShipAddressMessage":"Rr-z","changePayment":"Sr-z"};